<template>
  <div>
    <StarRating v-model="val" @rating-selected="onChange" :star-size="45" :show-rating="false"/>

    <answer-required-field v-if="!isvalid"></answer-required-field>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import AnswerRequiredField from "./AnswerRequiredField";
export default {
  name: "answer-star",
  components: {
    StarRating,
    AnswerRequiredField,
  },
  props: {
    required: Boolean,
  },
  data() {
    return {
      isvalid: true,
      visit: "",
      val: 0,
    };
  },
  methods: {
    value() {
      return { value: this.val };
    },
    isNegative() {
      return this.value().value < 3 && this.value().value > 0;
    },
    isValid() {
      return this.required ? (this.val > 0 ? true : false) : true;
    },
    validate() {
      this.isvalid = this.isValid();
      return this.isvalid;
    },
    onChange() {
      this.isvalid = true;
      this.$emit("changed", this.value());
    },
  },
};
</script>

<style lang="scss">
</style>